var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlopyDisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.75C4.30964 3.75 3.75 4.30964 3.75 5V19C3.75 19.6904 4.30964 20.25 5 20.25H19C19.6904 20.25 20.25 19.6904 20.25 19V7.82843C20.25 7.49691 20.1183 7.17896 19.8839 6.94454L17.0555 4.11612C16.821 3.8817 16.5031 3.75 16.1716 3.75H5ZM2.25 5C2.25 3.48122 3.48122 2.25 5 2.25H16.1716C16.9009 2.25 17.6004 2.53973 18.1161 3.05546L20.9445 5.88388C21.4603 6.39961 21.75 7.09908 21.75 7.82843V19C21.75 20.5188 20.5188 21.75 19 21.75H5C3.48122 21.75 2.25 20.5188 2.25 19V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 3.75V8.25H15.25V3.75H8.75ZM7.25 3.6C7.25 2.85442 7.85442 2.25 8.6 2.25H15.4C16.1456 2.25 16.75 2.85441 16.75 3.6V8.4C16.75 9.14558 16.1456 9.75 15.4 9.75H8.6C7.85442 9.75 7.25 9.14558 7.25 8.4V3.6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 13.75V20.25H17.25V13.75H6.75ZM5.25 13.6C5.25 12.8544 5.85442 12.25 6.6 12.25H17.4C18.1456 12.25 18.75 12.8544 18.75 13.6V21.75H5.25V13.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlopyDisk);
export default __webpack_public_path__ + "static/media/flopyDisk.6c0d4dd1ea2b3d08e8e15e11be072c59.svg";
export { ForwardRef as ReactComponent };